import i18next from 'i18next';
import en from './locales/en.json';

/**
 * Ako's learner-facing text for code that cannot use `useTranslation` (plain
 * hooks, class components). Uses the live i18next instance, and falls back to
 * the English catalogue when it has not been initialised (unit tests, early
 * boot) so the learner never sees a raw key.
 */
function lookup(tree: unknown, key: string): string | undefined {
  let node: unknown = tree;
  for (const part of key.split('.')) {
    if (node && typeof node === 'object' && part in (node as Record<string, unknown>)) {
      node = (node as Record<string, unknown>)[part];
    } else {
      return undefined;
    }
  }
  return typeof node === 'string' ? node : undefined;
}

export function akoText(key: string, vars: Record<string, string | number> = {}): string {
  const name = i18next.isInitialized ? i18next.t('companion.name') : lookup(en, 'companion.name') ?? 'Ako';
  const all = { name, ...vars };
  if (i18next.isInitialized) return i18next.t(key, all);
  const template = lookup(en, key) ?? key;
  return template.replace(/\{\{(\w+)\}\}/g, (_m, k: string) => String(all[k as keyof typeof all] ?? ''));
}

export default akoText;
